import Box from '@mui/material/Box'
import surveyNavPreviousIcon from '../../assets/survey-nav-previous-icon.svg'
import { surveyNavPreviousIconSx } from '../../styles/surveyExecutionStyles'

/** Figma 5074-13208 — 16×16 Previous arrow (#4D5D88 via parent color). */
export function SurveyNavPreviousIcon() {
  return (
    <Box
      component="img"
      src={surveyNavPreviousIcon}
      alt=""
      aria-hidden
      sx={surveyNavPreviousIconSx}
      data-testid="survey-nav-previous-icon"
    />
  )
}
